import React, {FC, useState} from 'react'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {schemaCategory} from '../../../../../util/validation'
import {CategoryModel} from '../../../model'
import {useCentral} from '../../../../../hooks/useCentral'
import ActionsContent from '../../componentes/Actions'
import ContainerWrapper from '../../componentes/Container'
import {TabCentralModel} from '../../../../../models'
import {ResizeHandle} from '../../../../hoteleria/components/Layout/Container/ResizeHandle/ResizeHandle'
import {createCategory, deleteCategory, updateCategory} from '../../../services'
import {renderPanelContent} from '../components'
import Swal from 'sweetalert2'
import {ShowSnackBar} from '../../../../../util/functions'
const CategoryPageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useCentral()
  const [loading, setLoading] = useState(false)
  const methods = useForm<CategoryModel>({
    resolver: yupResolver(schemaCategory),
  })
  const {reset} = methods

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        let id = currentTabItem.idToDelete

        try {
          const data = await deleteCategory(id)
          if (!data.data.error) {
            const obj: TabCentralModel = {
              ...currentTabItem,
              idToDelete: '',
              loadingTable: true,
            }

            changeCurrentTabItem(obj)
            ShowSnackBar('Se eliminó con éxito')
          } else {
            changeCurrentTabItem({...currentTabItem, loadingTable: false})
            ShowSnackBar(data.data.messageSystem, 'error')
          }

          setLoading(false)
        } catch (error) {
          setLoading(false)
          ShowSnackBar('Error interno', 'error')
        }

        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const onSubmit = async (data: CategoryModel) => {
    try {
      if (currentTabItem.idToEdit) {
        data.id = currentTabItem.idToEdit
        const response = await updateCategory(data)
        if (!response.data.error) {
          reset()
          ShowSnackBar('Se actualizó el registro correctamente')
          const obj: TabCentralModel = {
            ...currentTabItem,
            showPanel: false,
            content: {
              ...currentTabItem.content,
              headerPanel: 'table-category',
            },
            idToEdit: '',
            loadingTable: true,
          }

          changeCurrentTabItem(obj)
        } else {
          ShowSnackBar(response.data.messageSystem, 'error')
        }
      } else {
        const response = await createCategory(data)
        if (!response.data.error) {
          reset()
          ShowSnackBar('Se creó con éxito')
          const obj: TabCentralModel = {
            ...currentTabItem,
            content: {
              ...currentTabItem.content,
              headerPanel: 'table-category',
            },
          }
          changeCurrentTabItem(obj)
        } else {
          ShowSnackBar(response.data.messageSystem, 'error')
        }
      }

      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={handleDelete}
          loading={loading}
          textComponentBack='table-category'
          textComponentGo='form-category'
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-central-header-${currentTabItem.id}`}
              id={`panel-central-header-${currentTabItem.id}`}
              className={'panel__box'}
            >
              <>{renderPanelContent(currentTabItem.content.headerPanel)}</>
            </Panel>{' '}
            :
            <>
              {currentTabItem.showPanel && (
                <>
                  <ResizeHandle />
                  <Panel
                    className={'panel__box'}
                    collapsible={true}
                    defaultSize={50}
                    order={2}
                    key={`panel-central-detail-${currentTabItem.id}`}
                    id={`panel-central-detail-${currentTabItem.id}`}
                  >
                    {renderPanelContent(currentTabItem.content.detailPanel)}
                  </Panel>
                </>
              )}
            </>
          </PanelGroup>
        </ContainerWrapper>
      </form>
    </FormProvider>
  )
}

export default CategoryPageWrapper
